var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"box",on:{"click":_vm.showSearchMeth}},[_c('span',{staticClass:"foldBtn"},[_vm._v(_vm._s(_vm.fold.foldText))]),_c('i',{staticClass:"showIcon",class:_vm.fold.iconClass})])])
}
var staticRenderFns = []

export { render, staticRenderFns }